import React, {useEffect, useState} from 'react';
import {Box, makeStyles, Tab, Tabs, useTheme} from "@material-ui/core";
import PropTypes from "prop-types";
import {IoIosClose} from "react-icons/io";
import {useSelector} from "react-redux";
import {TextLink, Loader} from "../../../components";
import axios from "axios";
import {adminToken} from "../../../helper";
import styles from "../../../components/Table/styles.module.scss";
import { AWS_ROUTING, AWS_SERVER_APIS } from "configurations";

function getModalStyle() {
    const top = 50
    const left = 50

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}


const useStyles = makeStyles((theme) => ({
    indicator: {
        backgroundColor: "#6CD7BB"
    }
}))


const initialFilterState = {
    profileID: "",
    seniorId: "",
    seniorName: "",
    primaryPhoneNumber: "",
    homeID: "",
    gender: "",
    dateOfBirth: "",
    addressLine1: "",
    city: "",
    country: "",
    name: "",
    phoneNumber: "",
    relationshipToSenior: "",
    preferredCommunicationChannel: ""
};

const initialFilterState1 = {
    name: "",
    phoneNumber: "",
    relationshipToSenior: "",
    preferredCommunicationChannel: ""
};

function UpdateGrandAPPSeniorModel({tableRows, handleCloseUS, currentElderID, setRefreshPage}) {

    const [elderDetails, setElderDetails] = useState(null)
    const [filterState, setFilterState] = useState(initialFilterState);
    const [familyMembers, setFamilyMembers] = useState();

    useEffect(() => {
        adminToken().then(token => axios.get(`${AWS_SERVER_APIS}/getelderdetails?elder_id=${currentElderID}`, {
            headers: {Authorization: `Bearer ${token}`}
        }).then(response => {
            console.log('currentElderID ==>',currentElderID);
            console.log('=>', response.data.data)

            setElderDetails(response.data.data);
            let onlyfamilydata = [];
            response.data.data.map((item) => {
                let data = {
                    name: item.userfname+' '+item.userlname,
                    phoneNumber: item.usermobile,
                    relationshipToSenior: item.relationship_name,
                    preferredCommunicationChannel: item.channel_name
                }
                onlyfamilydata.push(data);
            })
            setFamilyMembers(onlyfamilydata);
            var elderdata = (response.data.data)?response.data.data[0]:[];
            setFilterState({
                profileID: elderdata.profile_id,
                seniorId: elderdata.elder_id,
                seniorName: elderdata.first_name+' '+elderdata.last_name,
                primaryPhoneNumber: elderdata.primary_phone_number,
                homeID: elderdata.home_id,
                gender: elderdata.gender_code,
                dateOfBirth: elderdata.date_of_birth,
                addressLine1: elderdata.address_line1,
                city: elderdata.city,
                country: elderdata.country,
                name: elderdata.userfname+' '+elderdata.userlname,
                phoneNumber: elderdata.usermobile,
                relationshipToSenior: elderdata.relationship_name,
                preferredCommunicationChannel: elderdata.channel_name
            });
        }).catch(e => console.log(e.message)))
    }, [])

    const [modalStyle] = useState(getModalStyle);
    const [spLoader, setSpLoader] = useState(false);
    
    const classes = useStyles()

    
    const loading = useSelector(state => state.loading);

    const handleChange = (index, field, value) => {
        setFamilyMembers((prev) =>
          prev.map((item, i) =>
            i === index ? { ...item, [field]: value } : item
          )
        );
    };
    
    return (
        <div style={modalStyle} className={'modal-paper-small update_senior_data'}>
            <div className={'modal-top-bar'}>
                <IoIosClose
                    size={20}
                    className={'modal-close'}
                    onClick={handleCloseUS}
                />
            </div>
            <div className={'modal-header'}>
                <h5>Update Senior In Grand App</h5>
            </div>
            <div className={'modal-body'}>
                {/* <h4>Head Data</h4> */}
                <table width="100%">
                    <tr>
                        <td>
                            Profile ID:
                            <input type="text" name="profileID" value={filterState?.profileID} autocomplete="off" onChange={e =>
                                setFilterState({...filterState, [e.target.name]: e.target.value})
                            }/>
                        </td>
                        <td>
                            Senior ID:
                            <input type="text" name="seniorId" value={filterState?.seniorId} autocomplete="off" onChange={e =>
                                setFilterState({...filterState, [e.target.name]: e.target.value})
                            }/>
                        </td>
                        <td>
                            Senior Name:
                            <input type="text" name="seniorName" value={filterState?.seniorName} autocomplete="off" onChange={e =>
                                setFilterState({...filterState, [e.target.name]: e.target.value})
                            }/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Primary Phone Number:
                            <input type="text" name="primaryPhoneNumber" value={filterState?.primaryPhoneNumber} autocomplete="off" onChange={e =>
                                setFilterState({...filterState, [e.target.name]: e.target.value})
                            }/>
                        </td>
                        <td>
                            Home ID:
                            <input type="text" name="homeID" value={filterState?.homeID} autocomplete="off" onChange={e =>
                                setFilterState({...filterState, [e.target.name]: e.target.value})
                            }/>
                        </td>
                        <td>
                            Gender:
                            <input type="text" name="gender" value={filterState?.gender} autocomplete="off" onChange={e =>
                                setFilterState({...filterState, [e.target.name]: e.target.value})
                            }/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Date Of Birth:
                            <input type="text" name="dateOfBirth" value={filterState?.dateOfBirth} autocomplete="off" onChange={e =>
                                setFilterState({...filterState, [e.target.name]: e.target.value})
                            }/>
                        </td>
                        <td>
                            
                        </td>
                        <td>
                            
                        </td>
                    </tr>
                </table>

                <h4>Primary ResidenceDetails Data</h4>
                <table width="100%">
                    <tr>
                        <td>
                            Address Line1:
                            <input type="text" name="addressLine1" value={filterState?.addressLine1} autocomplete="off" onChange={e =>
                                setFilterState({...filterState, [e.target.name]: e.target.value})
                            }/>
                        </td>
                        <td>
                            City:
                            <input type="text" name="city" value={filterState?.city} autocomplete="off" onChange={e =>
                                setFilterState({...filterState, [e.target.name]: e.target.value})
                            }/>
                        </td>
                        <td>
                            Country:
                            <input type="text" name="country" value={filterState?.country} autocomplete="off" onChange={e =>
                                setFilterState({...filterState, [e.target.name]: e.target.value})
                            }/>
                        </td>
                    </tr>
                </table>

                <h4>Family Members Data</h4>
                <table width="100%">
                    {
                        familyMembers?.map((item, index) => {
                            return (<tr>
                                <td>
                                    Name:
                                    <input type="text" name="name" value={item?.name} autocomplete="off" onChange={e =>
                                handleChange(index, [e.target.name], e.target.value)
                            }/>
                                </td>
                                <td>
                                    PhoneNumber:
                                    <input type="text" name="phoneNumber" value={item?.phoneNumber} autocomplete="off" onChange={e =>
                                handleChange(index, [e.target.name], e.target.value)
                            }/>
                                </td>
                                <td>
                                    Relationship To Senior:
                                    <input type="text" name="relationshipToSenior" value={item?.relationshipToSenior} autocomplete="off" onChange={e =>
                                handleChange(index, [e.target.name], e.target.value)
                            }/>
                                </td>
                                <td>
                                    Preferred Communication Channel:
                                    <input type="text" name="preferredCommunicationChannel" value={item?.preferredCommunicationChannel} autocomplete="off" onChange={e =>
                                handleChange(index, [e.target.name], e.target.value)
                            }/>
                                </td>
                            </tr>)
                        })
                    }
                </table>

                <hr></hr>
                
                <button className='btn btn-primary' onClick={(status) => {
                    setSpLoader(true);
                adminToken().then(token =>
                    axios.post(`${AWS_SERVER_APIS}/createnewsenior`, {
                        "NewSenior":{"profileID":filterState.profileID,"seniorId":filterState.seniorId,"seniorName":filterState.seniorName,"primaryResidenceDetails":
                            {"addressLine1":filterState.addressLine1,"city":filterState.city,"country":filterState.country},"primaryPhoneNumber":filterState.primaryPhoneNumber,"homeID":filterState.homeID,"gender":filterState.gender,"dateOfBirth":filterState.dateOfBirth,"familyMembers":familyMembers}
                    }, {headers: {Authorization: `Bearer ${token}`}})
                        .then(res => {
                            if(res.data.type == 'error'){
                                alert('Error: '+res.data.message);
                            }else{
                                alert('Added New Senior Successfull!');
                                handleCloseUS();
                                setRefreshPage(Math.floor(100000 + Math.random() * 900000))
                            }
                        })
                );
                }}>Add Senior</button> 

                <button className='btn btn-success' onClick={(status) => {
                    setSpLoader(true);
                adminToken().then(token =>
                    axios.post(`${AWS_SERVER_APIS}/createnewsenior`, {
                        "UpdateSenior":{"profileID":filterState.profileID,"seniorId":filterState.seniorId,"seniorName":filterState.seniorName,"primaryResidenceDetails":
                            {"addressLine1":filterState.addressLine1,"city":filterState.city,"country":filterState.country},"primaryPhoneNumber":filterState.primaryPhoneNumber,"homeID":filterState.homeID,"gender":filterState.gender,"dateOfBirth":filterState.dateOfBirth,"familyMembers":familyMembers}
                    }, {headers: {Authorization: `Bearer ${token}`}})
                        .then(res => {
                            if(res.data.type == 'error'){
                                alert('Error: '+res.data.message);
                            }else{
                                alert('Updated Senior Successfull!');
                                handleCloseUS();
                                setRefreshPage(Math.floor(100000 + Math.random() * 900000))
                            }
                        })
                );
                }}>Update Senior</button> {spLoader ? (
                    <div className={styles.loading__container}>
                      <Loader />
                    </div>
                  ) : null}
            </div>
        </div>
    );
}

export default UpdateGrandAPPSeniorModel;
